import { useEffect, useState } from "react";
import { History, AlertTriangle } from "lucide-react";
import adminApi from "@/lib/adminApi";
import { Card } from "@/components/ui/card";
import { fmtShift, fmtWhen } from "./shiftFormat";

// v2.8+E345 · no-shows from the last 90 days stay visible after the shift ends.
export const MissedShiftsCard = ({ refreshKey }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/schedule/missed", { params: { days: 90 } })
      .then(({ data }) => setRows(data?.shifts || []))
      .catch(() => setRows([]));
  }, [refreshKey]);

  if (rows === null) return null;

  return (
    <Card className="p-4" data-testid="missed-shifts-card">
      <div className="text-xs uppercase tracking-widest font-bold text-zinc-500 mb-3 flex items-center gap-1.5">
        <History className="h-4 w-4"/>Recent missed shifts · last 90 days ({rows.length})
      </div>
      {rows.length === 0 ? (
        <div className="text-sm text-zinc-400 py-4 text-center" data-testid="missed-shifts-empty">No missed shifts in the last 90 days.</div>
      ) : (
        <ul className="space-y-2 max-h-96 overflow-y-auto pr-1" data-testid="missed-shifts-list">
          {rows.map((s) => (
            <li key={s.id} data-testid={`missed-shift-${s.id}`} className="flex items-start justify-between gap-3 rounded-lg border border-rose-500/20 bg-rose-500/5 px-3 py-2.5">
              <div className="min-w-0">
                <div className="text-sm font-semibold flex items-center gap-1.5">
                  <AlertTriangle className="h-3.5 w-3.5 text-rose-500 shrink-0"/>{s.dispatcher_name}
                </div>
                <div className="text-[12px] text-zinc-500">{fmtShift(s)}</div>
                {s.note ? <div className="text-[11px] text-zinc-400 mt-0.5">{s.note}</div> : null}
              </div>
              <span className="text-[11px] text-right shrink-0 text-zinc-500" data-testid={`missed-shift-late-${s.id}`}>
                {s.late_clock_in
                  ? <>Clocked in late<br/><b className="text-amber-600 dark:text-amber-300">{fmtWhen(s.late_clock_in, { weekday: undefined, month: undefined, day: undefined })}</b></>
                  : <b className="text-rose-600 dark:text-rose-300">No-show</b>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};

export default MissedShiftsCard;
